/**
 * Created by superman on 17/2/16.
 * http配置
 */

import axios from 'axios';

// import store from '../store'
// import aes from './aes'

// axios 配置
axios.defaults.timeout = 10000
axios.defaults.baseURL = process.env.NODE_ENV === 'production' ? 'https://api.everjournal.life' : '';
axios.defaults.adapter = require('axios/lib/adapters/http');
axios.defaults.crossDomain = true
axios.defaults.withCredentials = true
axios.defaults.params = {};

// 默认headers
axios.defaults.headers = {
  Accept: '*/*',
  // 'Content-Type': 'application/json; charset=utf-8'
};

// http request 拦截器
axios.interceptors.request.use(
  config => {
    // console.log(config)
    config.headers = {
      ...config.headers,
      Authorization: localStorage.getItem('$$token')
    }
    return config;
  },
  err => {
    return Promise.reject(err)
  },
)

// http response 拦截器
axios.interceptors.response.use(
  response => {
    // console.log(response)
    const { data } = response;
    if (data.errcode === 200 || data.code === 0) {
      return Promise.resolve(data);
    } else {
      return Promise.reject(data);
    }
  },
  error => {
    return Promise.reject(error.response)
  },
)

const request = (opts = {}) => {
  const config = opts.config || {};

  return axios.request({
    url: opts.url,
    method: opts.method || 'post',
    headers: opts.headers || {},
    data: opts.data || {},
    params: opts.params || {},
    ...config
  });
}

export { request as $fetch };

export default {
  install: Vue => {
    Vue.prototype.$fetch = request;
  }
};
